<template>
    <div>
        <div class="card mb-3">
            <div class="card-header">
                基地基本信息
            </div>
            <div class="card-body text-danger" v-if="showWarningText">
                基地基本信息不可更改，若发生变更，请联系管理员
            </div>
            <table class="table table-bordered mb-0" v-if="organInfo">
                <tbody>
                <tr>
                    <th class="text-center align-middle" style="width: 15%">基地名称</th>
                    <td class="text-left align-middle" colSpan="5">{{ organInfo.organName }}</td>
                </tr>
                <tr>
                    <th class="text-center align-middle" style="width: 15%">所在城市</th>
                    <td class="text-left align-middle" style="width: 25%">{{ organInfo.provinceName }}
                        {{ organInfo.cityName }}
                    </td>
                    <th class="text-center align-middle" style="width: 15%">基地代码</th>
                    <td class="text-left align-middle" style="width: 15%">{{ organInfo.organCode }}</td>
                    <th class="text-center align-middle" style="width: 15%">状态</th>
                    <td class="text-left align-middle" style="width: 15%">{{ organInfo.stateName }}</td>
                </tr>
                </tbody>
            </table>
        </div>

    </div>

</template>

<script>
import dictionary from "@/utils/dictionary";
import userApi from "@/utils/api/user";
import CollegeOrganContactPersonView from "@/components/user/CollegeOrganContactPersonView";

export default {
    name: "OrganInfoView",
    components: {CollegeOrganContactPersonView},
    props: {
        organId: {type: String, required: true},
        showWarningText: {type: Boolean, required: false, default: false},
    },
    data: function () {
        return {
            personType: dictionary.personType.ORGAN_CONTACT,
            organInfo: {},
        };
    },
    mounted() {
        this.getOrganInfo();
    },
    methods: {
        getOrganInfo() {
            userApi.organ.getOrganUserInfoById(this.organId).then(res => {
                this.organInfo = res.data;
            });
        }
    }
}
</script>

<style scoped>

</style>